<app-loader *ngIf="isLoading"></app-loader>
<form method="post" *ngIf="!isLoading" [formGroup]="examAddressForm">
  <div class="col-6">
    <div class="form-group">
      <label>Város<span class="required-label" *ngIf="city.errors?.['required']">*</span></label>
      <input id="city" type="text" class="form-control" formControlName="city" maxlength="50" />
    </div>
    <div *ngIf="city.invalid && (city.dirty || city.touched)" class="alert alert-danger">
      <div *ngIf="city.errors?.['required']">A város kötelező.</div>
      <div *ngIf="city.errors?.['maxlength']">A város legfeljebb 50 karakter lehet.</div>
      <div *ngIf="city.errors?.['serverError']">{{city.errors?.['serverError']}}</div>
    </div>

    <div class="form-group">
      <label>Irányítószám<span class="required-label" *ngIf="postCode.errors?.['required']">*</span></label>
      <input id="postCode" type="text" class="form-control" formControlName="postCode" />
    </div>
    <div *ngIf="postCode.invalid && (postCode.dirty || postCode.touched)" class="alert alert-danger">
      <div *ngIf="postCode.errors?.['required']">Az irányítószám kötelező.</div>
      <div *ngIf="postCode.errors?.['pattern']">Az irányítószámnak 4 számból kell állnia!</div>
      <div *ngIf="postCode.errors?.['serverError']">{{postCode.errors?.['serverError']}}</div>
    </div>

    <div class="form-group">
      <label>Címsor 1<span class="required-label" *ngIf="line1.errors?.['required']">*</span></label>
      <input id="line1" type="text" class="form-control" formControlName="line1" maxlength="100" />
    </div>
    <div *ngIf="line1.invalid && (line1.dirty || line1.touched)" class="alert alert-danger">
      <div *ngIf="line1.errors?.['required']">A cím 1 kötelező.</div>
      <div *ngIf="line1.errors?.['maxlength']">A címsor 1 legfeljebb 100 karakter lehet.</div>
      <div *ngIf="line1.errors?.['serverError']">{{line1.errors?.['serverError']}}</div>
    </div>

    <div class="form-group">
      <label>Címsor 2</label>
      <input id="line2" type="text" class="form-control" formControlName="line2" maxlength="100" />
      <div *ngIf="line2.invalid && (line2.dirty || line2.touched)" class="alert alert-danger">
        <div *ngIf="line2.errors?.['maxlength']">A címsor 2 legfeljebb 100 karakter lehet.</div>
        <div *ngIf="line2.errors?.['serverError']">{{line2.errors?.['serverError']}}</div>
      </div>
    </div>
  </div>

  <div class="button-group">
    <button (click)="onSubmit()" class="btn btn-primary text-white btn-save me-2" [disabled]="examAddressForm.invalid">
      Mentés
    </button>
    <a
      (click)="onGoBack('/exam-addresses')"
       class="btn btn-dark">
      Vissza
    </a>
  </div>
</form>
